// extracted by mini-css-extract-plugin
module.exports = {"collapsible":"styles_collapsible__M_Ust"};